import React from 'react';
import { Outlet } from 'react-router-dom';
import Tab from '../components/Tab';
import { ImFilesEmpty } from 'react-icons/im';
import { MdHistory } from 'react-icons/md';
import { SiOpenaccess } from 'react-icons/si';

const InternalUserLayout = () => {
  return (
    <div className="min-h-screen w-full flex justify-center bg-white">
      {/* Centered container with responsive padding and max width */}
      <section className="w-full max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:py-6">
        <div className="w-full">
          {/* Responsive, scrollable tab bar on mobile */}
          <nav
            className="w-full overflow-x-auto border-b border-gray-200"
            aria-label="User sections"
          >
            <div className="flex items-center gap-2 sm:gap-4 whitespace-nowrap px-1 py-0">
              <Tab icon={<ImFilesEmpty />} path="my-desk" title="On My Desk" />
              <Tab icon={<MdHistory />} path="my-history" title="My History" />
              <Tab icon={<SiOpenaccess />} path="my-privilege" title="My Privilege Access" />
            </div>
          </nav>

          {/* Content */}
          <main className="mt-4 sm:mt-6">
            <Outlet />
          </main>
        </div>
      </section>
    </div>
  );
};

export default InternalUserLayout;
